import { render, staticRenderFns } from "./FontSizes.vue?vue&type=template&id=720f48c4&"
import script from "./FontSizes.vue?vue&type=script&lang=js&"
export * from "./FontSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports